import React, { FC } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/pro-light-svg-icons';

import styles from './index.module.sass';

interface MenuProps {
  onClick: () => void;
}

const Menu: FC<MenuProps> = ({ onClick }) => (
  <button className={styles.button} type="button" onClick={onClick}>
    <FontAwesomeIcon icon={faBars} />
  </button>
);

export default Menu;
